{
  "flags": {
    "defaultInputModeNone": true
  }
}
